// Mock data for 400 distressed assets (100 each category)

const cre_images = [
  'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
  'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800',
  'https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=800',
  'https://images.pexels.com/photos/998499/pexels-photo-998499.jpeg?w=800',
  'https://images.pexels.com/photos/35299316/pexels-photo-35299316.jpeg?w=800',
  'https://images.unsplash.com/photo-1656646424501-06d57009b725?w=800'
];

const foreclosure_images = [
  'https://images.pexels.com/photos/101808/pexels-photo-101808.jpeg?w=800',
  'https://images.pexels.com/photos/210617/pexels-photo-210617.jpeg?w=800'
];

const airplane_images = [
  'https://images.pexels.com/photos/35181749/pexels-photo-35181749.jpeg?w=800',
  'https://images.pexels.com/photos/35162898/pexels-photo-35162898.jpeg?w=800',
  'https://images.pexels.com/photos/46148/aircraft-jet-landing-cloud-46148.jpeg?w=800',
  'https://images.pexels.com/photos/728824/pexels-photo-728824.jpeg?w=800'
];

const company_images = [
  'https://images.pexels.com/photos/323705/pexels-photo-323705.jpeg?w=800',
  'https://images.pexels.com/photos/443383/pexels-photo-443383.jpeg?w=800',
  'https://images.unsplash.com/photo-1574958269340-fa927503f3dd?w=800',
  'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=800',
  'https://images.unsplash.com/photo-1600531529272-023c4b821f14?w=800',
  'https://images.pexels.com/photos/269077/pexels-photo-269077.jpeg?w=800',
  'https://images.pexels.com/photos/534219/pexels-photo-534219.jpeg?w=800'
];

const locations = [
  'New York, NY', 'Los Angeles, CA', 'Chicago, IL', 'Houston, TX', 'Phoenix, AZ',
  'Philadelphia, PA', 'San Antonio, TX', 'San Diego, CA', 'Dallas, TX', 'San Jose, CA',
  'Austin, TX', 'Jacksonville, FL', 'Fort Worth, TX', 'Columbus, OH', 'San Francisco, CA',
  'Charlotte, NC', 'Indianapolis, IN', 'Seattle, WA', 'Denver, CO', 'Boston, MA',
  'Miami, FL', 'Atlanta, GA', 'Detroit, MI', 'Portland, OR', 'Las Vegas, NV'
];

const statuses = ['Available', 'Pending Review', 'Under Evaluation', 'Available', 'Available'];

const generateCREAssets = () => {
  const assets = [];
  const types = ['Office Building', 'Retail Center', 'Industrial Warehouse', 'Mixed-Use Development', 'Shopping Mall'];
  
  for (let i = 1; i <= 100; i++) {
    // Generate values: first 60 are $100k - $3M, last 40 are $3M - $70M for institutional buyers
    let baseValue;
    if (i <= 60) {
      baseValue = 100000 + (i * 48000);
    } else {
      // Premium properties for large Bitcoin holders
      baseValue = 3000000 + ((i - 60) * 1675000);
    }
    
    assets.push({
      id: `cre-${i}`,
      name: `${types[i % types.length]} - ${locations[i % locations.length].split(',')[0]}`,
      type: 'Commercial Real Estate',
      category: 'cre',
      estimatedValue: baseValue,
      location: locations[i % locations.length],
      status: statuses[i % statuses.length],
      description: `Prime commercial real estate opportunity in ${locations[i % locations.length]}. This ${types[i % types.length].toLowerCase()} features modern amenities, excellent location, and strong rental history. Distressed asset available for immediate assumption with favorable terms.`,
      image: cre_images[i % cre_images.length],
      sqft: Math.floor(Math.random() * 150000) + 10000,
      yearBuilt: Math.floor(Math.random() * 30) + 1995,
      occupancyRate: Math.floor(Math.random() * 40) + 60
    });
  }
  return assets;
};

const generateForeclosureAssets = () => {
  const assets = [];
  const types = ['Single Family Home', 'Multi-Family Property', 'Condo Complex', 'Townhouse', 'Duplex'];
  
  for (let i = 1; i <= 100; i++) {
    // Generate values between $50k - $800k
    const baseValue = 50000 + (i * 7500);
    assets.push({
      id: `foreclosure-${i}`,
      name: `${types[i % types.length]} - ${locations[i % locations.length].split(',')[0]}`,
      type: 'Foreclosure',
      category: 'foreclosure',
      estimatedValue: baseValue,
      location: locations[i % locations.length],
      status: statuses[i % statuses.length],
      description: `Foreclosure property in ${locations[i % locations.length]}. This ${types[i % types.length].toLowerCase()} is available at below-market value. Great investment opportunity with potential for rental income or resale.`,
      image: foreclosure_images[i % foreclosure_images.length],
      bedrooms: Math.floor(Math.random() * 5) + 2,
      bathrooms: Math.floor(Math.random() * 3) + 1,
      sqft: Math.floor(Math.random() * 3000) + 1200
    });
  }
  return assets;
};

const generateAirplaneAssets = () => {
  const assets = [];
  const models = ['Boeing 737-800', 'Airbus A320', 'Boeing 777-300ER', 'Airbus A330-300', 'Boeing 787 Dreamliner', 
                  'Embraer E190', 'Bombardier CRJ900', 'Airbus A350-900'];
  
  for (let i = 1; i <= 100; i++) {
    // Generate values between $200k - $5M (smaller aircraft, parts, or shares)
    const baseValue = 200000 + (i * 48000);
    assets.push({
      id: `airplane-${i}`,
      name: `${models[i % models.length]} - ${i.toString().padStart(3, '0')}`,
      type: 'Aircraft',
      category: 'airplane',
      estimatedValue: baseValue,
      location: locations[i % locations.length],
      status: statuses[i % statuses.length],
      description: `${models[i % models.length]} share or parts package available for acquisition. Well-maintained aircraft components with comprehensive service history. Ideal for airlines, charter operators, or leasing companies looking to expand their fleet.`,
      image: airplane_images[i % airplane_images.length],
      manufacturer: models[i % models.length].split(' ')[0],
      model: models[i % models.length],
      yearManufactured: Math.floor(Math.random() * 15) + 2010,
      totalFlightHours: Math.floor(Math.random() * 50000) + 10000,
      seatingCapacity: Math.floor(Math.random() * 200) + 100
    });
  }
  return assets;
};

const generateCompanyAssets = () => {
  const assets = [];
  const industries = ['Technology', 'Manufacturing', 'Healthcare', 'Retail', 'Financial Services', 'Hospitality'];
  const companyTypes = ['Software Company', 'Manufacturing Plant', 'Medical Facility', 'Retail Chain', 'Bank Branch Network', 'Hotel Group'];
  
  for (let i = 1; i <= 100; i++) {
    // Generate values: first 60 are $150k - $5M, last 40 are $5M - $80M for institutional buyers
    let baseValue;
    if (i <= 60) {
      baseValue = 150000 + (i * 80000);
    } else {
      // Large companies for institutional buyers
      baseValue = 5000000 + ((i - 60) * 1875000);
    }
    
    assets.push({
      id: `company-${i}`,
      name: `${companyTypes[i % companyTypes.length]} ${i}`,
      type: 'Company',
      category: 'company',
      estimatedValue: baseValue,
      location: locations[i % locations.length],
      status: statuses[i % statuses.length],
      description: `Established ${companyTypes[i % companyTypes.length].toLowerCase()} in the ${industries[i % industries.length].toLowerCase()} sector. Strong market position with consistent revenue streams. Distressed sale presents unique acquisition opportunity.`,
      image: company_images[i % company_images.length],
      industry: industries[i % industries.length],
      employees: i <= 60 ? Math.floor(Math.random() * 100) + 10 : Math.floor(Math.random() * 1000) + 100,
      annualRevenue: baseValue * 0.8,
      yearEstablished: Math.floor(Math.random() * 30) + 1995
    });
  }
  return assets;
};

export const allAssets = [
  ...generateCREAssets(),
  ...generateForeclosureAssets(),
  ...generateAirplaneAssets(),
  ...generateCompanyAssets()
];

export const getAssetsByCategory = (category) => {
  if (!category || category === 'all') return allAssets;
  return allAssets.filter(asset => asset.category === category);
};

export const getAssetById = (id) => {
  return allAssets.find(asset => asset.id === id);
};
